import _defineProperty from '@babel/runtime/helpers/defineProperty';
import styled, { css } from 'styled-components';
import { themeWithVariant, siteThemes, variant, isDefaultTheme } from '../../utils/theming.js';
import mq from '../../utils/mediaQueries.js';

var backgroundColor = themeWithVariant('site', '$variant', {
  basic: css(["rgba(32,32,32,0.8)"]),
  ksp: _defineProperty(_defineProperty({}, siteThemes.DEFAULT, css(["var(--color-background-surface-secondary)"])), siteThemes.GLOBETROTTER, css(["var(--color-quartz-200)"])),
  success: css(["var(--color-notif-system-success)"]),
  error: css(["var(--color-notif-system-error)"]),
  alert: css(["var(--color-notif-system-alert)"]),
  info: css(["var(--color-notif-system-info)"]),
  urgency: css(["var(--color-notif-urgency-primary)"]),
  sale: css(["var(--color-rouge-500)"])
}, css(["rgba(32,32,32,0.8)"]));
var textColor = function textColor() {
  return function (_ref) {
    var $variant = _ref.$variant,
      site = _ref.theme.site;
    var variantsWithDarkText = site === siteThemes.GLOBETROTTER ? ['ksp', 'alert', 'error', 'sale', 'success'] : ['ksp', 'info', 'alert', 'urgency'];
    if (variantsWithDarkText.includes($variant)) {
      return css(["var(--color-text)"]);
    }
    return css(["var(--color-text-inverse)"]);
  };
};
var font = function font() {
  return function (_ref2) {
    var $small = _ref2.$small,
      $responsive = _ref2.$responsive,
      $variant = _ref2.$variant,
      $lowercase = _ref2.$lowercase,
      site = _ref2.theme.site;
    if (site === siteThemes.GLOBETROTTER) {
      return css(["font:var(--font-mini);text-transform:uppercase;padding:var(--space-100) var(--space-200);"]);
    }
    var fontSize = '1.4rem';
    var padding = '6px var(--space-200)';
    if ($small) {
      fontSize = '1.2rem';
    }
    if ($variant === 'sale') {
      fontSize = '1.9rem';
      padding = 'var(--space-100) var(--space-200)';
    }
    return css(["font-family:var(--font-family-headline);font-size:", ";line-height:1;padding:", ";text-transform:", ";", ""], fontSize, padding, $lowercase ? 'none' : 'uppercase', $responsive && $variant !== 'sale' && css(["", ""], mq.sMax(css(["font-size:1.2rem;"]))));
  };
};
var hoverColor = variant('$variant', {
  quartz: css(["var(--color-quartz-300)"]),
  gray: css(["var(--color-black)"])
});
var Tag = styled.div.withConfig({
  displayName: "style__Tag",
  componentId: "sc-1qomgm-0"
})(["", " cursor:default;display:inline-flex;gap:var(--space-100);justify-content:center;align-items:center;background:", ";color:", ";transition:color var(--transition),background var(--transition);", " ", " ", ""], font, backgroundColor, textColor, function (_ref3) {
  var $filterTag = _ref3.$filterTag;
  return $filterTag && css(["padding:var(--space-200);gap:var(--space-200);"]);
}, isDefaultTheme(css(["border-radius:var(--border-radius-200);"])), function (_ref4) {
  var as = _ref4.as;
  return as === 'button' && css(["cursor:pointer;&:hover{background:", ";}"], hoverColor);
});
var Icon = styled.span.withConfig({
  displayName: "style__Icon",
  componentId: "sc-1qomgm-1"
})(["line-height:0;"]);

export { Icon, Tag };
//# sourceMappingURL=style.js.map
